import { render, staticRenderFns } from "./SolicitudesCambios.vue?vue&type=template&id=19764b57&scoped=true"
import script from "./SolicitudesCambios.vue?vue&type=script&lang=js"
export * from "./SolicitudesCambios.vue?vue&type=script&lang=js"
import style0 from "./SolicitudesCambios.vue?vue&type=style&index=0&id=19764b57&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19764b57",
  null
  
)

export default component.exports